module.exports = __webpack_public_path__ + "static/media/06.9206c53f.png";